import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import {
  LuBrain,
  LuCheck,
  LuCircleCheck,
  LuCloud,
  LuCloudSun,
  LuCog,
  LuHeart,
  LuLayers,
  LuList,
  LuPlus,
  LuScale,
  LuShieldCheck,
  LuStar,
  LuUsers,
} from "react-icons/lu";

const traits = [
  {
    icon: <LuBrain className="text-[#822bda] w-6 h-6" />,
    title: "Adaptability",
    desc: "Adjusts to new situations, handles change positively",
  },
  {
    icon: <LuShieldCheck className="text-[#822bda] w-6 h-6" />,
    title: "Stress Tolerance",
    desc: "Manages pressure effectively, maintains composure",
  },
  {
    icon: <LuHeart className="text-[#822bda] w-6 h-6" />,
    title: "Empathy",
    desc: "Understands others’ feelings, shows compassion",
  },
  {
    icon: <LuStar className="text-[#822bda] w-6 h-6" />,
    title: "Creativity",
    desc: "Generates original ideas, thinks innovatively",
  },
  {
    icon: <LuCloud className="text-[#822bda] w-6 h-6" />,
    title: "Positive Mindset",
    desc: "Demonstrates optimism, focuses on solutions",
  },
  {
    icon: <LuLayers className="text-[#822bda] w-6 h-6" />,
    title: "Integrity",
    desc: "Acts honestly and ethically, maintains principles",
  },
  {
    icon: <LuCheck className="text-[#822bda] w-6 h-6" />,
    title: "Achievement Drive",
    desc: "Pursues goals with determination, strives for excellence",
  },
  {
    icon: <LuCircleCheck className="text-[#822bda] w-6 h-6" />,
    title: "Conscientiousness",
    desc: "Demonstrates reliability, attention to detail",
  },
  {
    icon: <LuList className="text-[#822bda] w-6 h-6" />,
    title: "Critical Thinking",
    desc: "Evaluates information objectively, makes logical decisions",
  },
  {
    icon: <LuCog className="text-[#822bda] w-6 h-6" />,
    title: "Self-management",
    desc: "Organizes time and tasks efficiently, works independently",
  },
  {
    icon: <LuPlus className="text-[#822bda] w-6 h-6" />,
    title: "Initiative",
    desc: "Takes action proactively, identifies opportunities",
  },
  {
    icon: <LuUsers className="text-[#822bda] w-6 h-6" />,
    title: "Teamwork",
    desc: "Collaborates effectively, contributes to group goals",
  },
];

const TraitsSection = () => {
  return (
    <section className="py-20 px-6 md:px-14 lg:px-20 bg-[#f6f8fe]">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">The 12 Traits</h2>
        <p className="text-gray-600 max-w-2xl mx-auto text-base md:text-lg">
          Selfsync evaluates these key personality dimensions to create a
          comprehensive profile of workplace potential.
        </p>
      </div>

      <div className="hidden md:grid md:grid-cols-3 lg:grid-cols-4 gap-6">
        {traits.map((trait, index) => (
          <div
            key={index}
            className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 group hover:-translate-y-1"
          >
            <div className="bg-[#f6f2fe] w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:bg-purple-200 transition-colors">
              {trait.icon}
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {trait.title}
            </h3>
            <p className="text-gray-600 text-sm">{trait.desc}</p>
          </div>
        ))}
      </div>
      <div className="md:hidden">
        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={1}
          navigation={{
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
          }}
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }}
          className="relative"
        >
          {traits.map((trait, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 group hover:-translate-y-1 mx-auto max-w-sm">
                <div className="bg-purple-100 w-10 h-10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-purple-200 transition-colors">
                  {trait.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {trait.title}
                </h3>
                <p className="text-gray-600 text-sm">{trait.desc}</p>
              </div>
            </SwiperSlide>
          ))}

          {/* Custom Arrows */}
          <div className="flex justify-center mt-6 gap-4">
            <button className="swiper-prev w-10 h-10 flex items-center justify-center rounded-full border text-gray-600 hover:bg-gray-100">
              <FaArrowLeft />
            </button>
            <button className="swiper-next w-10 h-10 flex items-center justify-center rounded-full border-2 border-purple-600 text-purple-600 hover:bg-purple-100">
              <FaArrowRight />
            </button>
          </div>
        </Swiper>
      </div>
    </section>
  );
};

export default TraitsSection;
